import './gift-controls.scss';

import { useTranslation } from 'react-i18next';

import type { GiftFilter, GiftSortBy } from '../../types';

type GiftControlsProps = {
  filter: GiftFilter;
  sortBy: GiftSortBy;
  onFilterChange: (f: GiftFilter) => void;
  onSortChange: (s: GiftSortBy) => void;
};

export function GiftControls({ filter, sortBy, onFilterChange, onSortChange }: GiftControlsProps) {
  const { t } = useTranslation();

  return (
    <div className="gift-controls">
      <div className="gift-controls__filters">
        <button
          className={`gift-controls__filter${filter === 'all' ? ' gift-controls__filter--active' : ''}`}
          onClick={() => onFilterChange('all')}>
          {t('shop.filterAll')}
        </button>
        <button
          className={`gift-controls__filter${filter === 'lost' ? ' gift-controls__filter--active' : ''}`}
          onClick={() => onFilterChange('lost')}>
          {t('shop.filterLost')}
        </button>
      </div>
      <div className="gift-controls__sorts">
        <button
          className={`gift-controls__sort${sortBy === 'price_asc' ? ' gift-controls__sort--active' : ''}`}
          onClick={() => onSortChange('price_asc')}>
          {t('shop.sortPriceAsc')}
        </button>
        <button
          className={`gift-controls__sort${sortBy === 'price_desc' ? ' gift-controls__sort--active' : ''}`}
          onClick={() => onSortChange('price_desc')}>
          {t('shop.sortPriceDesc')}
        </button>
        <button
          className={`gift-controls__sort${sortBy === 'name_az' ? ' gift-controls__sort--active' : ''}`}
          onClick={() => onSortChange('name_az')}>
          {t('shop.sortNameAz')}
        </button>
      </div>
    </div>
  );
}
